<div class="wrapper wrapper-dark p-relative">

  <div class="title-section mb-5">{{"Mission and Vision"|translate}}</div>

  <div class="box-wrap">
    <div class="light-box box-mission p-relative">
      <div class="round-green">
        <img src="./assets/img/mission_icon.svg" width="40">
      </div>
      <div class="font-20 bolder text-center mb-3">MISSION</div>
      <span class="justify" *ngFor="let item of getMissions()">
        {{item}} <br> <br>
      </span>
    </div>
    <div class="light-box box-vision p-relative">
      <div class="round-green">
        <img src="./assets/img/vision_icon.svg" width="45">
      </div>
      <div class="font-20 bolder text-center mb-3">VISION</div>
  
      <span class="justify" *ngFor="let item of getVisions()">
        {{item}} <br> <br>
      </span>
    </div>
  </div>
  <div class="light-box border-green mb-4">
    <div class="bolder font-14 mb-3">
      {{"Codici ATECO"|translate}}
    </div>

    <div class="box-codici">
      <span class="col-codici">
        <div class="bold mb-1">
          {{"Prevalente"|translate}} - 62.01
        </div>
        <div>
          {{"Prevalente_1"|translate}}
        </div>
      </span>

      <span class="col-codici">
        <div class="bold mb-1">
          {{"Secondari"|translate}} - 43.21.01
        </div>
        <div>
          {{"Secondari_1"|translate}}
        </div>
      </span>

      <span class="col-codici">
        <div class="bold mb-1">
          {{"Secondari"|translate}} - 43.29.09
        </div>
        <div>
          {{"Secondari_2"|translate}}
        </div>
      </span>
    </div>

  </div>
</div>

<div class="wrapper p-relative">

  <div class="box-certificates">
    <img class="mr-3" src="./assets/img/kiwa.png" width="80">
    <img class="mr-3" src="./assets/img/soa.png" width="130">
    <img src="./assets/img/unicert.png" width="120">
  </div>

  <div class="title-section mb-5">
    {{"Partner and solutions"|translate}}
  </div>

  <div class="d-inline-b w-100 font-12 v-top margin-top wrapper-service text-center">
    <div class="box-service">
      <span>
        <a href="https://www.wonderware.it/contatti/system-integrator/" target="_blank">
          <img class="mr-3" src="./assets/img/partner/Factory_Software.png" width="35%" alt="Factory Software"></a>
      </span>
    </div>
    <div class="box-service">
      <span>
        <a href="https://www.wonderware.it/contatti/system-integrator/" target="_blank">
          <img class="mr-3" src="./assets/img/partner/aveva.png" width="90%" alt="AVEVA"></a>
      </span>
    </div>
    <div class="box-service">
      <span>
        <a href="https://www.se.com/ww/en/locate/accounts/0011H00001kyM8HQAU" target="_blank">
          <div class="mb-1">Alliance integration partner</div>
          <img class="mr-3" src="./assets/img/partner/schneider.png" width="70%" alt="Schneider Alliance Partner"></a>
      </span>
    </div>
    <div class="box-service">
      <span>
        <!--<a href="" target="_blank">-->
          <img class="mr-3" src="./assets/img/partner/ignition.png" width="90%" alt="Ignition">
        <!-- </a> -->
      </span>
    </div>
    <div class="box-service">
      <span>
        <!-- <a href="" target="_blank"> -->
          <img class="mr-3" src="./assets/img/partner/PcVue.png" width="90%" alt="PcVue">
        <!-- </a> -->
      </span>
    </div>
    <div class="box-service">
      <span>
        <!-- <a href="" target="_blank"> -->
          <img class="mr-3" src="./assets/img/partner/ABB.png" width="70%" alt="ABB">
        <!-- </a> -->
      </span>
    </div>
    <div class="box-service">
      <span>
        <!-- <a href="" target="_blank"> -->
          <img class="mr-3" src="./assets/img/partner/Siemens.png" width="90%" alt="Siemens">
        <!-- </a> -->
      </span>
    </div>
    <div class="box-service">
      <span>
        <a href="./assets/img/partner/Certificato_EcoXpert_2024_SPS_SRL.pdf" target="_blank">
          <img class="mr-3" src="./assets/img/partner/EcoXpert.png" width="90%" alt="EcoXpert - Schneider Electic"></a>
      </span>
    </div>
  </div>
</div>